<div class="wrapper-md">
    <app-breadcrumbs [items]="[
                     { url: '/midterm-exam-payments', text: 'midtermExamPayment_listTitle' },
                     { url: '/midterm-exam-payments/add', text: 'midtermExamPayment_addTitle' }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>{{'midtermExamPayment_addTitle' | translate}}</h1>
    </header>

    <app-person-picker *ngIf="studentPickerOpened" (pick)="pickStudent($event)"></app-person-picker>

    <form #form="ngForm" *ngIf="!studentPickerOpened">
        <div class="row">
            <div class="form-field col-md-8 required">
                <label class="form-label">{{'midtermExamPayment_lblStudent' | translate}}</label>
                <input class="form-control" [value]="studentDisplay" disabled required *ngIf="!canPickStudent" />
                <div class="input-group" *ngIf="canPickStudent">
                    <input class="form-control" [value]="studentDisplay" disabled required />
                    <button class="btn btn-outline" type="button" (click)="studentPickerOpened = true">
                        <i class="fi fi-rs-pencil"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="form-field required">
            <label class="form-label">{{'midtermExamPayment_lblCourse' | translate}}</label>
            <app-select [(ngModel)]="course"
                        [options]="courses"
                        [displayFn]="courseDisplayFn"
                        [required]="true"
                        (selectionChange)="onCourseChange($event)"
                        name="course">
                <ng-template #optionTemplate let-option>
                    <div>
                        <div>{{option.Code}} - {{option.Name}}</div>
                        <div class="text-sub">{{option.Semester}}</div>
                    </div>
                </ng-template>
            </app-select>
        </div>

        <div class="row">
            <div class="form-field required col-md-6">
                <label class="form-label">{{'midtermExamPayment_lblTeacher' | translate}}</label>
                <app-select [(ngModel)]="teacher"
                            [options]="teachers"
                            [displayFn]="teacherDisplayFn"
                            [required]="true"
                            [disabled]="!course"
                            name="teacher">
                </app-select>
            </div>
        </div>

        <div class="form-field required">
            <label class="form-label">{{'midtermExamPayment_lblReason' | translate}}</label>
            <textarea class="form-control" [(ngModel)]="reason" name="reason" rows="5" #reasonInput="ngModel" required
                      [pattern]="getMaxLengthValidationPattern(progress, reasonMaxLength)"></textarea>
            <div class="feedback" *ngIf="!reason?.length || reasonInput.valid">{{(reason || '').length}}/{{reasonMaxLength}}</div>
            <div class="invalid-feedback" *ngIf="reason?.length && reasonInput.invalid">
                {{'fieldError_lengthMinMax' | translate | formatString:[0, reasonMaxLength]}}
            </div>
        </div>

        <div class="row">
            <div class="col-sm-4 form-field required">
                <label class="form-label">{{'midtermExamPayment_lblAmount' | translate}}</label>
                <input class="form-control" [value]="amount | number:'1.2-2':'en-US'" disabled required />
            </div>
        </div>

        <div class="form-actions">
            <button class="btn btn-outline-primary" type="button" (click)="submit()" [disabled]="!form.valid">
                {{'continue' | translate}}
            </button>

            <button class="btn btn-outline" type="button" [routerLink]="['/midterm-exam-payments'] | localize">
                {{'cancel' | translate}}
            </button>
        </div>
    </form>

    <div #paymentFormContainer style="display: none"></div>
</div>
